import {
  CaretRightOutlined,
  RightOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Row, Col, Form, Input, Divider, Select , Button , Space} from "antd";
import React, { useEffect, useState } from "react";
import accountService from "../../../api/account.service";
import { FORM_NAME_COMPONENT_DETAILS_ADMISSION, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
const { Option } = Select;


function TestFormItem() {
  const [serviceList, setServiceList] = useState([{ service: "" }]);

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...serviceList];
    list[index][name] = value;
    setServiceList(list);
  };

  const handleServiceRemove = (index) => {
    const list = [...serviceList];
    list.splice(index, 1);
    setServiceList(list);
  };

  const handleServiceAdd = () => {
    setServiceList([...serviceList, { service: "" }]);
  };

  return (
    <form className="App" autoComplete="off">
      <div className="form-field">
        <label htmlFor="service">Service(s)</label>
        {serviceList.map((singleService, index) => (
          // <div key={index} className="services">
          //   <div className="first-division">
          //     <input
          //       name="service"
          //       type="text"
          //       id="service"
          //       value={singleService.service}
          //       onChange={(e) => handleServiceChange(e, index)}
          //       required
          //     />
          //     {serviceList.length - 1 === index && serviceList.length < 4 && (
          //       <button
          //         type="button"
          //         onClick={handleServiceAdd}
          //         className="add-btn"
          //       >
          //         <span>Add a Service</span>
          //       </button>
          //     )}
          //   </div>
          //   <div className="second-division">
          //     {serviceList.length !== 1 && (
          //       <button
          //         type="button"
          //         onClick={() => handleServiceRemove(index)}
          //         className="remove-btn"
          //       >
          //         <span>Remove</span>
          //       </button>
          //     )}
          //   </div>
          // </div>




          <div >
                <Row
                
                  style={{
                    display: "flex",
                    marginBottom: 8,
                    borderBottom: "0px solid red",
                  }}
                  align="baseline"
                  gutter={15}
                >
                  <Col xs={24} xl={4}>
                    <Form.Item
                    
                      name={["das", "description"]}
                      rules={[
                        { required: true, message: "" },
                      ]}
                      label="Component"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                  </Col>
                  <Col xs={24} xl={2}>
                    <Form.Item
                   
                      name={["das", "amount"]}
                      rules={[{ required: true, message: "" }]}
                      label="Amount"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  
                </Row>
                <Space>
                <MinusCircleOutlined onClick={() => handleServiceRemove(index)} />
                </Space>
                
                <Divider />
              </div>

        ))}
      </div>

      <div className="output">
        <h2>Output</h2>
        {serviceList &&
          serviceList.map((singleService, index) => (
            <ul key={index}>
              {singleService.service && <li>{singleService.service}</li>}
            </ul>
          ))}
      </div>

    </form>
  );
}

export default TestFormItem;